import React, { useEffect } from 'react';

import usePageTitle from '../../hooks/usePageTitle';
import ManageAgencyForm from './ManageAgencyForm';
import { usePageHeader } from '../../contexts/PageHeaderContext';

export function AddAgency() {
    usePageTitle('Add Agency');
    const { setPageHeader } = usePageHeader();

    // Set up page header
    useEffect(() => {
        setPageHeader('Add Agency');
        return () => setPageHeader(null);
    }, [setPageHeader]);

    return (
        <div className="container-fixed">
            <ManageAgencyForm />
        </div>
    );
}